<template>
  <Dropdown
    :items="posStates"
    :item-key="(state) => state.key"
    :item-to-string="(state) => state.name"
    :value="dropDownValue"
    @change="onPosStateChange"
  >
    <template #items></template>
    <template #bottom-content>
      <button
        class="text-btn link-main icon-link status-guide-btn"
        @click="openStatusGlossary"
      >
        <Icon icon="info-circle" />
        {{ $t('DESIGNS.LIST.STATUS_GLOSSARY_CTA') }}
      </button>
    </template>
  </Dropdown>
</template>

<script setup>
import Dropdown from 'commons/Dropdown/Dropdown.vue';
import { i18n } from 'commons/translate/i18n';
import dialogService from 'commons/dialogs/wrapper/dialogService';
import { computed } from 'vue';
import { COMPOSITION_POS_STATES } from 'commons/api/models/publishingCore/compositionPosStates';
import { useCompositionsStore } from 'commons/stores/compositions';
import PublishingStatusDialog from './PublishingStatusDialog.vue';

const { t } = i18n.global;

const compositionsStore = useCompositionsStore();
const emits = defineEmits(['posStateChanged']);

const posStates = computed(() => {
  const { total, stateCounts } = compositionsStore.posStateCounts;
  const states = Object.values(COMPOSITION_POS_STATES).map((it) => {
    const stateCount = stateCounts[it.key];
    return { ...it, value: it.key, name: `${t(it.name)} (${stateCount})` };
  });

  states.unshift({
    key: 'ALL',
    value: null,
    name: `${t('GENERAL.ALL')} (${total})`,
  });

  return states;
});

const dropDownValue = computed(() => {
  const state = compositionsStore.filter.posState;
  return posStates.value.find((it) =>
    state ? it.key === state : it.key === 'ALL',
  );
});

const onPosStateChange = (selectedState) => {
  compositionsStore.setFilter({
    posState: selectedState.value,
    page: 0,
  });
  emits('posStateChanged');
};

const openStatusGlossary = () => {
  dialogService.openDialog(PublishingStatusDialog);
};
</script>
